<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.doorcredential_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          v-show="scope.row.credentialType == 1 && scope.row.cardReceived != 1"
          type="text"
          size="small"
          icon="el-icon-s-finance"
          @click="openCollectCardDialog(scope.row)"
          >领卡
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="openDelayDateDialog(scope.row)"
          >延期
        </el-button>
        <el-button
          v-show="scope.row.status != 2"
          type="text"
          size="small"
          icon="el-icon-remove-outline"
          @click="cancal(scope.row)"
        >
          注销
        </el-button>
      </template>
      <template slot="status" slot-scope="scope">
        <el-tag type="danger" style="font-size: 8px;" size="medium" v-show="scope.row.status == 2"
          >注销</el-tag
        >
        <el-tag type="success" style="font-size: 8px;" size="medium" v-show="scope.row.status == 1"
          >正常</el-tag
        >
        <el-tag type="warning" style="font-size: 8px;" size="medium" v-show="scope.row.status == 0"
          >过期</el-tag
        >
      </template>
      <template slot="cardReceived" slot-scope="scope">
        <el-tag
          type="danger"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.cardReceived == 0"
          >未领取</el-tag
        >
        <el-tag
          type="success"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.cardReceived == 1"
          >已领取</el-tag
        >
      </template>
      <template slot="cardSynced" slot-scope="scope">
        <el-tag
          type="danger"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.cardSynced == 0"
          >未下发</el-tag
        >
        <el-tag
          type="success"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.cardSynced == 1"
          >已下发</el-tag
        >
      </template>
    </avue-crud>
    <el-dialog
      title="领卡"
      append-to-body
      :visible.sync="collectCardFlag"
      @closed="closedDialog(1)"
    >
      <avue-form
        v-model="collectCardForm"
        ref="collectCardRef"
        :option="collectCardOption"
        @submit="collectCardSubmit"
      >
      </avue-form>
    </el-dialog>
    <el-dialog
      title="延期"
      append-to-body
      :visible.sync="delayFlag"
      @closed="closedDialog(2)"
      width="30%"
    >
      <avue-form v-model="delayForm" ref="delayFormRef" :option="delayOption" @submit="delaySubmit">
      </avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getDoorInfoByCommunityId,
  getDeviceByCommunityId,
  getAreaByBaseInfoId,
  delay,
  getPerson,
  getPersonDetail,
  collectCard,
  cancel,
} from '@/api/v4ward/door/credentail/doorcredential';
import { lazyBasePropertyTree } from '@/api/v4ward/property/baseproperty';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      collectCardForm: {},
      delayForm: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      collectCardFlag: false,
      delayFlag: false,
      endTimeTemp: '',
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        menuAlign: 'left',
        menuWidth: 200,
        dialogWidth: '50%',
        columnBtn: false,
        column: [
          {
            //仅仅用于搜索，解决因为使用小区名称列表搜索时，因为change事件想后台发送请求
            label: '小区名称',
            prop: 'communityIds',
            type: 'tree',
            search: true,
            hide: true,
            display: false,
            props: {
              label: 'communityName',
              value: 'communityId',
            },
            dicUrl: '/api/door/baseinfo/getCommunityFromDoorInfo',
          },
          {
            label: '小区名称',
            prop: 'communityId',
            type: 'tree',
            width: 130,
            overHidden: true,
            props: {
              label: 'communityName',
              value: 'communityId',
            },
            dicUrl: '/api/door/baseinfo/getCommunityFromDoorInfo',
            change: ({ value, column }) => {
              getDoorInfoByCommunityId(value).then((res) => {
                const baseInfoIdColumn = this.findObject(this.option.column, 'baseInfoId');
                baseInfoIdColumn.dicData = res.data;
              });
              getDeviceByCommunityId(value).then((res) => {
                const deviceListColumn = this.findObject(this.option.column, 'deviceList');
                deviceListColumn.dicData = res.data;
              });
            },
            rules: [
              {
                required: true,
                message: '小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '门禁名称',
            prop: 'baseInfoId',
            type: 'tree',
            hide: true,
            dicData: [],
            props: {
              label: 'doorInfoName',
              value: 'doorInfoId',
            },
            change: ({ value, column }) => {
              getAreaByBaseInfoId(value).then((res) => {
                const areaListColumn = this.findObject(this.option.column, 'areaList');
                areaListColumn.dicData = res.data;
              });
            },
            rules: [
              {
                required: true,
                message: '请选择门禁名称',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '门禁区域',
            prop: 'areaList',
            type: 'tree',
            hide: true,
            dicData: [],
            dataType: 'string',
            multiple: true,
            props: {
              label: 'areaName',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择门禁区域',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '门禁设备',
            prop: 'deviceList',
            type: 'tree',
            dicData: [],
            hide: true,
            multiple: true,
            dataType: 'string',
            props: {
              label: 'deviceName',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择门禁设备',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '凭证类型',
            search: true,
            prop: 'credentialType',
            type: 'select',
            addDisplay: false,
            dicUrl: '/api/blade-system/dict/dictionary?code=door_credential_type',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请选择凭证类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '凭证号',
            prop: 'credentialNo',
            rules: [
              {
                required: true,
                message: '请输入凭证号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '凭证密码',
            search: true,
            prop: 'credentialKey',
            width: 80,
            rules: [
              {
                required: true,
                message: '请输入凭证密码',
                trigger: 'change',
              },
            ],
          },
          {
            label: '卡面号码',
            search: true,
            prop: 'cardNo',
            rules: [
              {
                required: true,
                message: '请输入卡面号码',
                trigger: 'change',
              },
            ],
          },
          {
            label: '领取状态',
            search: true,
            addDisplay: false,
            prop: 'cardReceived',
            type: 'select',
            slot: true,
            width: 80,
            dicUrl: '/api/blade-system/dict/dictionary?code=card_received',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
          {
            label: '持有人',
            display: false,
            search: true,
            width: 70,
            prop: 'personName',
            overHidden: true,
          },
          {
            label: '房间',
            prop: 'propertyName',
            addDisabled: true,
            editDisabled: true,
            width: 250,
            overHidden: true,
          },
          {
            label: '下发状态',
            prop: 'cardSynced',
            slot: true,
            addDisplay: false,
            width: 80,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=card_synced',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
          {
            label: '凭证起期',
            type: 'date',
            prop: 'serviceStartDate',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入凭证起期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '凭证止期',
            type: 'date',
            width: 100,
            prop: 'serviceEndDate',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请输入凭证止期',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.serviceStartDate);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('凭证止期必须大于凭证起期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '状态',
            prop: 'status',
            addDisplay: false,
            editDisplay: false,
            slot: true,
            width: 70,
            type: 'select',
            dicData: [
              {
                label: '正常',
                value: 1,
              },
              {
                label: '已过期',
                value: 0,
              },
              {
                label: '已注销',
                value: 2,
              },
            ],
            dataType: 'number',
          },
          {
            label: '下发时间',
            prop: 'syncTime',
            display: false,
            hide: true,
            format: 'yyyy-MM-dd',
          },
          {
            label: '下发人员',
            prop: 'syncBy',
            hide: true,
            display: false,
          },
        ],
      },
      delayOption: {
        align: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        span: 24,
        column: [
          {
            label: '凭证起期',
            type: 'date',
            prop: 'serviceStartDate',
            format: 'yyyy-MM-dd',
            disabled: true,
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请输入凭证起期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '凭证止期',
            type: 'date',
            prop: 'serviceEndDate',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            rules: [
              {
                required: true,
                message: '请输入凭证止期',
                trigger: 'blur',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.delayForm.serviceStartDate);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('凭证止期必须大于凭证起期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
        ],
      },
      collectCardOption: {
        align: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '凭证号',
            prop: 'credentialNo',
            disabled: true,
          },
          {
            label: '凭证密码',
            prop: 'credentialKey',
            disabled: true,
          },
          {
            label: '卡面号码',
            prop: 'cardNo',
            disabled: true,
          },
          {
            label: '凭证起期',
            type: 'date',
            prop: 'serviceStartDate',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            disabled: true,
            rules: [
              {
                required: true,
                message: '请输入凭证起期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '凭证止期',
            type: 'date',
            prop: 'serviceEndDate',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            disabled: true,
            rules: [
              {
                required: true,
                message: '请输入凭证止期',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.delayForm.serviceStartDate);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('凭证止期必须大于凭证起期！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区名称',
            prop: 'communityId',
            type: 'tree',
            hide: true,
            disabled: true,
            props: {
              label: 'communityName',
              value: 'communityId',
            },
            dicUrl: '/api/door/baseinfo/getCommunityFromDoorInfo',
          },
          {
            lazy: true,
            label: '房间',
            prop: 'propertyId',
            type: 'tree',
            communityId: '',
            span: 12,
            rules: [
              {
                required: true,
                message: '请选择房间',
                trigger: 'change',
              },
            ],
            props: {
              labelText: '标题',
              label: 'objectFullName',
              value: 'value',
              children: 'children',
              disabled: true,
            },
            treeLoad: function (node, resolve, val) {
              const id = node.data.id;
              if (node.level !== 0) {
                lazyBasePropertyTree(id).then((res) => {
                  resolve(
                    res.data.map((item) => {
                      return {
                        ...item,
                        leaf: !item.hasChildren,
                      };
                    })
                  );
                });
              }
            },
            change: ({ value, column }) => {
              this.collectCardForm.personId = '';
              const personIdColumn = this.findObject(this.collectCardOption.column, 'personId');
              getPerson(value).then((res) => {
                personIdColumn.dicData = res.data;
                this.collectCardForm.personId = personIdColumn.dicData[0].id;
              });
            },
          },
          {
            label: '住户名称',
            prop: 'personId',
            type: 'select',
            dicData: [],
            props: {
              label: 'householdName',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请输入住户名称',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.doorcredential_add, true),
        viewBtn: this.vaildData(this.permission.doorcredential_view, false),
        delBtn: this.vaildData(this.permission.doorcredential_delete, false),
        editBtn: this.vaildData(this.permission.doorcredential_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    openDelayDateDialog(row) {
      getDetail({ id: row.id }).then(({ data }) => {
        this.delayForm.id = data.id;
        this.delayForm.serviceStartDate = data.serviceStartDate;
        this.delayForm.serviceEndDate = data.serviceEndDate;
        this.endTimeTemp = data.serviceEndDate;
      });
      this.delayFlag = true;
    },
    openCollectCardDialog(row) {
      getDetail({ id: row.id }).then(({ data }) => {
        this.collectCardForm.id = data.id;
        this.collectCardForm.serviceStartDate = data.serviceStartDate;
        this.collectCardForm.serviceEndDate = data.serviceEndDate;
        this.collectCardForm.credentialNo = data.credentialNo;
        this.collectCardForm.credentialKey = data.credentialKey;
        this.collectCardForm.cardNo = data.cardNo;
        this.collectCardForm.communityId = data.communityId == null ? '' : data.communityId;
        this.collectCardForm.personId = data.personId == null ? '' : data.personId;
        //初始化懒加载树，只作为查询人员的筛选条件
        const propertyIdsColumn = this.findObject(this.collectCardOption.column, 'propertyId');
        lazyBasePropertyTree(data.communityId).then((res) => {
          propertyIdsColumn.communityId = data.communityId;
          propertyIdsColumn.dicData = res.data;
        });
        if (this.vdui.isNotEmpty(data.personId)) {
          const propertyIdsColumn = this.findObject(this.collectCardOption.column, 'personId');
          getPersonDetail(data.personId).then((res) => {
            let dataList = [];
            dataList.push(res.data);
            propertyIdsColumn.dicData = dataList;
          });
        }
      });
      this.collectCardFlag = true;
    },
    rowSave(row, done, loading) {
      row.credentialType = 1;
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    //延期
    delaySubmit(row, done) {
      //原凭证止期临时变量
      let endTimeTemp = Date.parse(this.endTimeTemp);
      //当前最新凭证止期
      let dateEnd = Date.parse(row.serviceEndDate);
      let nowDate = Date.now();
      if (dateEnd <= nowDate) {
        this.$message.error('延期需大于当前时间！');
        done();
        return;
      }
      /*if (dateEnd <= endTimeTemp) {
        this.$message.error('新凭证止期需大于上一次止期！');
        done();
        return;
      }*/
      delay(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
          this.delayFlag = false;
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    //领卡
    collectCardSubmit(row, done) {
      collectCard(this.collectCardForm).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
          this.collectCardFlag = false;
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    closedDialog(flag) {
      if (flag == 1) {
        this.$refs.collectCardRef.resetForm();
      }
      if (flag == 2) {
        this.$refs.delayFormRef.resetForm();
      }
    },
    //注销数据
    cancal(row) {
      if (row.status === 2) {
        this.$message.error('该数据已经注销,请勿重复操作！');
        return;
      }
      this.$confirm('确定将选择数据注销?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        row.status = 2;
        cancel(row).then(
          () => {
            this.onLoad();
            this.$message.success('操作成功!');
          },
          (error) => {
            window.console.log(error);
          }
        );
      });
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          getDoorInfoByCommunityId(this.form.communityId).then((res) => {
            const baseInfoIdColumn = this.findObject(this.option.column, 'baseInfoId');
            baseInfoIdColumn.dicData = res.data;
          });
          getDeviceByCommunityId(data.communityId).then((res) => {
            const deviceListColumn = this.findObject(this.option.column, 'deviceList');
            deviceListColumn.dicData = res.data;
          });
          getAreaByBaseInfoId(data.baseInfoId).then((res) => {
            const areaListColumn = this.findObject(this.option.column, 'areaList');
            areaListColumn.dicData = res.data;
          });
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.vdui.isNotEmpty(this.query.communityIds)) {
        this.query.communityId = this.query.communityIds;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
